{
  "#PALETTEN_UMLAGERUNG": {
    "APP": "Umlagerung Palette",
    "APP_DESC": "Interne Lagerumbuchung",
    "TITLE": "Umlagerung Palette",
    "APP_DESCRIPTION": "Interne Lagerumbuchung",
    "STEP": "Schritt {{step}} von {{total}}",
    "PAGES": {
      "PALETTE_SCANNEN": {
        "TITLE": "Palette Scannen",
        "DESCRIPTION": "Bitte scannen Sie einen Paletten-Barcode"
      },
      "LAGERPLATZ_SCANNEN": {
        "TITLE": "Ziellagerplatz scannen",
        "DESCRIPTION": "Bitte scannen Sie den Ziellagerplatz",
        "PALETTE": "Umlagerung von Palette"
      }
    },
    "MESSAGES": {
      "SUCCESS": {
        "UMLAGERUNG": "Die Palette wurde dem neuen Lagerplatz zugewiesen"
      }
    }
  }
}
